<template>
    <section v-if="hasPermissions(['Budgeting-Forecaster Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>

        <div class="view__description">
            <p class="view__description__text" v-html="message"/>
        </div>

        <div class="row" style="margin-top:20px; margin-bottom: -25px;">
            <div class="col-md-8 col-sm-12 pt-0">
                <div class="row mb-0">
                    <div class="col-md-8 col-sm-12 pt-0">
                        <div class="row mb-0 no-gutters">
                            <div class="col-12">
                                <div class="row mb-0 forecaster__radiobuttons">
                                    <div v-for="(value, i) in radio_options" :key="i" :class="value.div_class">
                                        <input 
                                            v-model="task_type"
                                            :class="value.input_class"
                                            type="radio"
                                            :id="value.ref"
                                            name="radio"
                                            @change="radio_filter($event)"
                                            :value="value.ref"
                                            :checked="i === radio_options.length - 1 ? true : false"
                                        />
                                        <label :for="value.ref" :class="'form-check-label radiobutton__text custom-control-label'" v-html="value.name"/>
                                    </div> 
                                </div>

                            </div>
                            <div class="col-12">
                                <div class="row no-gutters mb-0">
                                    <form @submit.prevent="modify_records()">
                                        <div class="row m-0 formdynamic justify-content-md-between">
                                            <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
                                                <div class="formdynamic__item__field">
                                                    <label v-html="`Find rooms with this task: <b style='color:red;'>*</b>`" class="modal-label"/>
                                                    <select class="input-field custom-select" :style="`font-size:12px; height: 32px;`" :required="true" v-model="form_data.task_id">
                                                        <option value='' v-html="'Select an option'"/>
                                                        <option v-for="(value, i) in array_options.task_id" :key="i" :value="value.id" v-html="value.name"/>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
                                                <div class="formdynamic__item__field">
                                                    <label v-html="`Current frequency:`" class="modal-label"/>
                                                    <input :type="'number'" :min="0" :max="365" v-on:input="debounceInput({value: $event.target.value, field:'frequency'})" v-if="freq_manual"/>
                                                    <select class="input-field custom-select" :style="`font-size:12px; height: 32px;`" v-model="form_data.frequency" v-else>
                                                        <option value='' v-html="'Select an option'"/>
                                                        <option v-for="(value, i) in array_options.frequency_id" :key="i" :value="value.id" v-html="value.name"/>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
                                                <div class="formdynamic__item__field">
                                                    <label v-html="`Modify to use this task: <b style='color:red;'>*</b>`" class="modal-label"/>
                                                    <select class="input-field custom-select" :style="`font-size:12px; height: 32px;`" v-model="form_data.new_task_id">
                                                        <option value='' v-html="'Select an option'"/>
                                                        <option v-for="(value, i) in array_options.new_task_id" :key="i" :value="value.id" v-html="value.name"/>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6 forecaster__select__item p-0 formdynamic__item">
                                                <div class="formdynamic__item__field">
                                                    <label v-html="`New frequency: <b style='color:red;'>*</b>`" class="modal-label"/>
                                                    <input :type="'number'" :min="0" :max="365" v-on:input="debounceInput({value: $event.target.value, field:'new_frequency'})" v-if="freq_manual"/>
                                                    <select class="input-field custom-select" :style="`font-size:12px; height: 32px;`" v-model="form_data.new_frequency" v-else>
                                                        <option value='' v-html="'Select an option'"/>
                                                        <option v-for="(value, i) in array_options.frequency_id" :key="i" :value="value.id" v-html="value.name"/>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </form>
                                </div>
                                
                            </div>
                              
                        </div>
                    </div>
                </div>
            </div> 
        </div>
        <hr />
        <div class="row" style="margin-top:-40px;">
            <div class="col-md-8">
                <div class="row m-0 formdynamic justify-content-md-between">
                    <div class="col-md-3  p-0 formdynamic__item">
                        <div class="formdynamic__item__field">
                            <label
                                v-html="'Building:'"
                                class="modal-label"/>
                            <select
                                class="input-field custom-select" :style="`font-size:12px; height: 32px;`"
                                v-model="form_data.building_id"
                                :disabled="form_data.task_id ? false : true">
                                <option value="" v-html="'Select an option'" />
                                <option
                                v-for="(value, i) in array_options.building_id"
                                :key="i"
                                :value="value.id"
                                v-html="value.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3  p-0 formdynamic__item">
                        <div class="formdynamic__item__field">
                            <label
                                v-html="'Level: '"
                                class="modal-label"/>
                            <select
                                class="input-field custom-select" :style="`font-size:12px; height: 32px;`"
                                v-model="form_data.level_id"
                                :disabled="form_data.task_id ? false : true">
                                <option value="" v-html="'Select an option'" />
                                <option
                                v-for="(value, i) in array_options.level_id"
                                :key="i"
                                :value="value.id"
                                v-html="value.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3  p-0 formdynamic__item">
                        <div class="formdynamic__item__field">
                            <label
                                v-html="'Area:'"
                                class="modal-label"/>
                            <select
                                class="input-field custom-select" :style="`font-size:12px; height: 32px;`"
                                v-model="form_data.area_id"
                                :disabled="form_data.task_id ? false : true">
                                <option value="" v-html="'Select an option'" />
                                <option
                                v-for="(value, i) in array_options.area_id"
                                :key="i"
                                :value="value.id"
                                v-html="value.name"/>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-0">
                <div class="row mb-0">                       
                    <button v-if="hasPermissions(['Budgeting-Forecaster Write'])" class="modal__buttons__item w-auto ml-sm-2 px-3 ml-md-2" v-html="'Modify records'" @click="modify_records()" :class="{'disabled button__disabled' : !selected}" :disabled="!selected"/>
                    <button v-if="hasPermissions(['Budgeting-Forecaster Read']) && room_list && room_list.length" class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Print'" @click="exportPDF()"/>
                </div>
            </div>
        </div>
        <div class="col-md-12 pt-0 pb-0" v-if="room_list.length">
            <div class="row pt-0 pb-0 mb-0 pl-0">                       
                <div class="col-md-3 pt-0 formdynamic__item">
                    <div class="formdynamic__item__field">
                        <label v-html="`Hours Work Week:`" class="modal-label"/>
                        <input id="hours_work_week" placeholder="Default value is 40 unless otherwise specified" :type="'number'" :value="form_data.hours_work_week" :min="0" :max="365" v-on:input="debounceInput({value: $event.target.value, field:'hours_work_week'})"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive  table-fix-head" :style="`max-height: 35rem`" v-if="room_list.length">
            <table class="table">
                <thead>
                    <tr style="background-color: #0085DC; color: #fff">
                        <th colspan="3" class="new-header"></th>
                        <th colspan="5" class="new-header">CURRENT</th>
                        <th colspan="7" class="new-header">PROPOSED</th>
                    </tr>
                    <tr>
                        <th class="header-item-manual" scope="col">
                            <span class="custom-control custom-checkbox">
                                <input :id="`selectAll`" v-model="select_all" type="checkbox" class="custom-control-input" @change="selectAllBoxes()"/>
                                <label :for="`selectAll`" class="custom-control-label"/>
                            </span>
                        </th>
                        <th class="header-item-manual" v-for="(item, i) in table_headers" :key="i" scope="col" v-html="item.name" :style=" item.style ? item.style : ''"/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in room_list" :key="i">
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`select${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                <label :for="`select${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td v-html="item.custom_description"/>
                        <td v-html="item.sq_ft"/>
                        <td v-html="item.task"/>
                        <td v-html="item.production_standard"/>
                        <td v-html="item.frequency"/>
                        <td v-html="item.room_task_minutes"/>
                        <td v-html="item.annual_minutes"/>
                        <td v-html="item.fake_task_name"/>
                        <td v-html="item.fake_production_standard"/>
                        <td v-html="item.fake_frequency"/>
                        <td v-html="item.format_fake_daily_minutes"/>
                        <td v-html="item.fake_annual_minutes"/>
                        <td v-html="item.daily_diference"/>
                        <td v-html="item.annual_diference"/>
                    </tr>
                </tbody>
                <tfoot style="font-weight: 900">
                    <tr>
                        <td v-html="'TOTALS'"/>
                        <td />
                        <td v-html="totals.sq_ft ? totals.sq_ft : ''"/>
                        <td colspan="4"/>
                        <td v-html="totals.annual_minutes ? totals.annual_minutes : ''"/>
                        <td colspan="3"/>
                        <td v-html="totals.fake_daily_minutes ? totals.fake_daily_minutes : ''"/>
                        <td v-html="totals.fake_annual_minutes ? totals.fake_annual_minutes : ''"/>
                        <td v-html="totals.daily_diference ? totals.daily_diference : ''"/>
                        <td v-html="totals.annual_diference ? totals.annual_diference : ''"/>
                    </tr>
                    <tr>
                        <td v-html="'FTES'"/>
                        <td colspan="6"/>
                        <td v-html="ftes.annual_minutes ? ftes.annual_minutes : ''"/>
                        <td colspan="4"/>
                        <td v-html="ftes.fake_annual_minutes ? ftes.fake_annual_minutes : ''"/>
                        <td v-html="ftes.daily_diference ? ftes.daily_diference : ''"/>
                        <td v-html="ftes.annual_diference ? ftes.annual_diference : ''"/>
                    </tr>
                </tfoot>
            </table>

        </div>

        <FormModal 
            :title="'Search Room'"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :breadcrumb="breadcrumb"
            :array_options="array_options"
            :task_id="form_data.task_id"
            @arrayPush="array_push($event)"
            @dinamicTask="dinamic_task($event)"
        />
        <WaitingModal/>

        <HelperModal :helps="helps"/>

    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>

</template>

<script>

import axios            from 'axios'
import Breadcrumb       from '@/components/BreadcrumbComponent/Breadcrumb'
import FormModal        from './FormModal'
import WaitingModal     from '@/components/WaitingModal'
import Resources        from './resources'
import localMethods     from './localMethods'
import FormResources    from './form_resources'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import HelperModal          from    '@/components/HelperModal'
import 'vuetify/dist/vuetify.min.css'
import { Notyf }        from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
  
    name: 'Forecaster',

    components: {
        Breadcrumb,
        WaitingModal,
        FormModal,
        UnauthorizedComponent,
        HelperModal
    },

    mixins:[
        localMethods,
    ],

    data(){
        return{
            notyf,
            axios,
            report_root: {
                    name: 'Forecaster Report'
                },
            title_page:         'Forecaster',
            company_name:       'Digital Solutions, SE & Associates, Inc.',
            title_room_tab:     'Rooms',
            rest_api:           `forecasters`,
            general_rest_api:    'general_functions',
            notifications:      this.$store.state.form_notyf,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            radio_options:      Resources.radio_options,
            form_data:          FormResources.form_data,
            form_format:        FormResources.form_format,
            headers_report_table: Resources.headers_report_table,
            add_btn:            'Add Forecaster',
            single_select:      false,
            select_all:         false,
            freq_manual:        true,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            forecasters:        [],
            room_list:          [],
            room_cache:         [],
            room_table:         [],
            radio_value:        false,
            array_options:      {},
            task_type:          'all',
            totals:             {},
            ftes:               {},
            message: 'Select a Task with a Frequency (Optional). Click "Search Rooms" to see the list of rooms. If you wish to modify the task or frequency, select the new Task with a Frequency. Select the Rooms you wish to modify from the list, then click "Modify Records".',
            helps:              Resources.helps
        }
    },
}
</script>